// @flow
import * as React from 'react';
import './ConnectButton.scss';
import {defineMessages, FormattedMessage} from 'react-intl';

type ConnectButtonProps = {|
  token: string,
|};

const messages = defineMessages({
  label: {
    id: 'docsShell.connectButton.label',
    description:
      'Button label for a button -- reads "Connect with Stripe" but the Stripe logo is displayed via CSS',
    defaultMessage: 'Connect with',
  },
});

export const ConnectButton = ({token}: ConnectButtonProps) => {
  // Copied over from legacy site-srv code to unblock markdoc migration -- this could be cleaned up
  return (
    <a
      className="ConnectButton"
      href={`https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${token}&scope=read_write`}
    >
      <span>
        <FormattedMessage {...messages.label} />
      </span>
    </a>
  );
};
